import React from 'react'
import { Avatar } from '@mui/material'
import { nothing } from '$func/utils'
import { BadgeWrapper } from '$common/badge/styled-badge'
import { ChatListItem } from '../chat-list-item'
import { WithQueryPrivateSpaceListItemTitle } from './with-query-private-space-list-item-title'

interface Props {
  SecondaryActionIcon?: React.ComponentType<unknown>
  hasDivider?: boolean
  onClick?: () => unknown
  onSecondaryActionIconClick?: () => unknown
  onContextMenu?: (e: Event) => unknown
  selected?: boolean
  searchQuery: string
}

export function SearchedPrivateSpaceListItemWithStatus({
  SecondaryActionIcon,
  hasDivider = true,
  onClick = nothing,
  onContextMenu = nothing,
  selected = false,
  onSecondaryActionIconClick = nothing,
  searchQuery,
}: Props) {
  return (
    <ChatListItem
      avatarComponent={
        <BadgeWrapper selected={selected}>
          <Avatar src="assets/svg/private-space.svg" />
        </BadgeWrapper>
      }
      primaryText={<WithQueryPrivateSpaceListItemTitle query={searchQuery} />}
      SecondaryActionIcon={SecondaryActionIcon}
      hasDivider={hasDivider}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onSecondaryActionIconClick={onSecondaryActionIconClick}
    />
  )
}
